// Product image zoom/unzoom (prevent cart or menu button from being clicked when zoomed in on an image)
$('.pswp__button--close').on('pswpTap', function (event) {
    event.stopPropagation()
})

/************************************************ popups *****************************************************/

$(document).on('click', '.popup-article-block .open-popup', function() {
    var popup = $(this).siblings('.popup')
    popup.css('z-index', 100)
    popup.show()
})

$(document).on( 'click', '.koulutukset .post', function(e) {
    if( ! $(e.target).hasClass('.popup') && ! $(e.target).closest('.popup').length > 0 ) {
        $(this).find('.popup').css('z-index', 100)
        $(this).find('.popup').show()
    }
})

$('.close-popup').on( 'click', function() {
    $(this).closest('.popup').css('z-index', 1)
    $(this).closest('.popup').hide()

    var hasOpenPostParameter = hasURLParameter('open-post');
    if( hasOpenPostParameter ) {
        var currentUrl = new URL(window.location.href);
        var newUrl = removeURLParameter(currentUrl, 'open-post');
        window.history.replaceState({}, document.title, newUrl);
    }
})

// close popup when clicking outside of .popup-container
$(document).on('click', '.popup', function() {
    $(this).css('z-index', 1)
    $(this).hide()
})

// prevent from unintentionally closing when clicking inside .popup-container
$('.popup .popup-container').on('click', function(event) {
    event.stopPropagation()
})

$(document).on('click', '.blog-post-list.post .open-popup.post', function() {

    var baseUrl = window.location.protocol + "//" + window.location.host + "/";
    if(baseUrl == 'http://localhost/') {
        baseUrl = 'http://localhost/seoptimi/'
    }
    var apiUrl = baseUrl + '/wp-json/wp/v2/posts/';

    // Replace '{post_id}' with the ID of the specific post you want to retrieve
    var postSlug = $(this).attr('post-slug');

    var popup = $(this).closest('.blog-post-list.post').find('.popup')

    // Make the AJAX request to the WordPress REST API
    $.ajax({
        url: apiUrl,
        data: { slug: postSlug, _embed: true },
        method: 'GET',
        success: function(data) {

            var response = data[0]
            popup.find('.post-content').html(response.content.rendered);

            if(response.featured_media) {
                var thumbnailUrl = response._embedded['wp:featuredmedia'][0].source_url;
                popup.find('.post-content').prepend('<div class="thumbnail-image"><img src="' + thumbnailUrl + '" alt="Thumbnail"></div>');
            }

            var hasOpenPostParameter = hasURLParameter('open-post');
            if( ! hasOpenPostParameter ) {
                var currentUrl = window.location.href;
                var separator = currentUrl.indexOf('?') !== -1 ? '&' : '?';
                var newUrl = currentUrl + separator + 'open-post=' + postSlug;
                window.history.replaceState({}, document.title, newUrl);
            }

            popup.css('z-index', 100)
            popup.show()
        },
        error: function(error) {
            console.error('Error fetching post:', error);
        }
    });

})

$(document).ready( function() {
    var hasOpenPostParameter = hasURLParameter('open-post');
    if( hasOpenPostParameter ) {
        var currentUrl = new URL(window.location.href);
        var openPostValue = getURLParameterValue(currentUrl, 'open-post');
        $('.blog-post-list .open-popup.post[post-slug=' + openPostValue + ']').click()
    }
})

function getURLParameterValue(url, parameterKey) {
    var urlParams = new URLSearchParams(url.search);
    return urlParams.get(parameterKey);
}

function hasURLParameter(parameterKey) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(parameterKey);
}

function removeURLParameter(url, parameterKey) {
    url = url.toString();
    var urlParts = url.split('?');
    if (urlParts.length >= 2) {
      var prefix = encodeURIComponent(parameterKey) + '=';
      var params = urlParts[1].split(/[&;]/g);

      for (var i = params.length; i-- > 0;) {
        if (params[i].lastIndexOf(prefix, 0) !== -1) {
          params.splice(i, 1);
        }
      }

      url = urlParts[0] + (params.length > 0 ? '?' + params.join('&') : '');
    }
    return url;
}

/************************************************ post filters *****************************************************/

$('.blog-post-list.post .filter').change( function() {
    
    var post_list_element = $(this).closest('.blog-post-list')
    var date = $(this).closest('.filters').find('#date').val() || 'all';
    var author = $(this).closest('.filters').find('#author').val() || 'all';
    var ppp = $(this).closest('.blog-post-list').attr('amount')
    var category = $(this).closest('.blog-post-list').attr('category')
    var tag = $(this).closest('.filters').find('#subject').val() || 'all';

    get_posts_list(post_list_element, 'post', ppp, category, 'default', date, 'all', author, 'all', 'all', tag )

    if(tag !== 'all') {
        var hasTagsParameter = hasURLParameter('aihealue');
        var currentUrl = window.location.href;
        var separator = currentUrl.indexOf('?') !== -1 ? '&' : '?';
        if( ! hasTagsParameter ) {
            var newUrl = currentUrl + separator + 'aihealue=' + tag;
        } else {
            var urlParams = new URLSearchParams(window.location.search);
            urlParams.set('aihealue', tag);
            var newUrl = window.location.pathname + '?' + urlParams.toString() + window.location.hash;
        }
        window.history.replaceState({}, document.title, newUrl);
    } else {
        var hasTagsParameter = hasURLParameter('aihealue');
        if( hasTagsParameter ) {
            var currentUrl = new URL(window.location.href);
            var newUrl = removeURLParameter(currentUrl, 'aihealue');
            window.history.replaceState({}, document.title, newUrl);
        }
    }

})

$('.koulutukset .filter').change( function() {

    var post_list_element = $(this).closest('.blog-post-list')
    var date = $(this).closest('.filters').find('#date').val() || 'all';
    var type = $(this).closest('.filters').find('#type').val() || 'all';
    var place = $(this).closest('.filters').find('#place').val() || 'all';
    var form = $(this).closest('.filters').find('#form').val() || 'all';
    var order = $(this).closest('.filters').find('#order').val() || 'default';
    var ppp = $(this).closest('.blog-post-list').attr('amount')
    var category = $(this).closest('.blog-post-list').attr('category')
    if( category == '' ) {
        category = $(this).closest('.filters').find('#cat').val() || 'all';
    }

    get_posts_list( post_list_element, 'koulutukset', ppp, category, order, date, place, 'all', type, form, 'all' )

})

function get_posts_list(post_list_element, post_type, ppp, category, order, date, place, author, type, form, tag) {
    $.ajax({
        type: "POST",
        dataType: "json",
        url: ajaxurl,
        data: {
            'action': 'filter_posts_ajax',
            'posttype': post_type,
            'ppp': ppp,
            'category': category,
            'order': order,
            'date': date,
            'place': place,
            'author': author,
            'type': type,
            'form': form,
            'tag': tag
        },
        success: function(data){
            if(data.html) {
                post_list_element.find('.post-container .posts').html(data.html)
            }
        },
        error : function(jqXHR, textStatus, errorThrown) {
            console.log(jqXHR, textStatus, errorThrown);
        }

    });
    return false;
}

/* show cta buttons */
$(document).ready(function() {
    $(window).scroll(function() {
      if ($(window).width() > 599) {
        if ($(this).scrollTop() > $(window).height() * 0.6) {
          $('.side-bar-buttons').fadeIn(200);
        } else {
          $('.side-bar-buttons').fadeOut(200);
        }
      }
    });
  });
